import $ from 'jquery';
import { gsap, TweenMax } from 'gsap';

gsap.registerPlugin(TweenMax);

$(document).ready(function () {
	function cursor(container, cursor) {
		var container = document.querySelector(container),
			circle = document.querySelector(cursor);

		if (!container) return;

		TweenMax.set(circle, {
			scale: 0,
			xPercent: -50,
			yPercent: -50,
		});

		container.addEventListener('pointerenter', function (e) {
			TweenMax.to(circle, 0.3, {
				scale: 1,
				autoAlpha: 1,
			});
			positionCircle(e);
		});

		container.addEventListener('pointerleave', function (e) {
			TweenMax.to(circle, 0.3, {
				scale: 0,
				autoAlpha: 0,
			});
			positionCircle(e);
		});

		container.addEventListener('pointermove', function (e) {
			positionCircle(e);
		});

		function positionCircle(e) {
			var rect = container.getBoundingClientRect();
			var relX = e.pageX - container.offsetLeft;
			var relY = e.pageY - container.offsetTop;

			TweenMax.to(circle, 0.3, {
				x: relX,
				y: relY,
			});
		}
	}

	function cursorHide(targetEl, targetCursor) {
		var container = document.querySelectorAll(targetEl),
			circle = document.querySelector(targetCursor);

		if (!container) return;

		container.forEach(function (element, index) {
			element.addEventListener('pointerenter', function (e) {
				TweenMax.to(circle, 0.3, {
					scale: 0,
					autoAlpha: 0,
				});
			});
			element.addEventListener('pointerleave', function (e) {
				TweenMax.to(circle, 0.3, {
					scale: 1,
					autoAlpha: 1,
				});
			});
		});
	}

	//init faq cursor
	cursor('.pdp-gallery__slides', '.pdp-galleries__cursor');
	cursorHide('.pdp-galleries__thumbs', '.pdp-galleries__cursor');
});
